import { useSyncExternalStore } from "react";
import CacheManager from "../classes/CacheManager";
import { CacheDataState } from "../types";

type Selector<T> = (state: CacheDataState) => T;

// Define selector pattern with useSyncExternalStore
// Single hook with selector pattern
export function useCacheManagerStore<Selected>(
  selector: Selector<Selected>,
  equalityFn: (a: Selected, b: Selected) => boolean = Object.is
): Selected {
  // Use useSyncExternalStore to subscribe to the store
  // and return the value selected by the selector
  let lastSelectedState: Selected = selector(CacheManager.getState());

  return useSyncExternalStore(
    CacheManager.subscribe,
    // getSnapshot only returns new state if selector returns different value
    () => {
      const nextState = selector(CacheManager.getState());

      if (!equalityFn(lastSelectedState, nextState)) {
        lastSelectedState = nextState;
      }

      return lastSelectedState;
    }
  );
}
